export const NAV_LINKS = [
    { label: 'Home', href: '/' },
    { label: 'Articles', href: '/articles' },
    { label: 'Projects', href: '/projects' },
] as const;

export const SOCIAL_LINKS = [
    {
        name: 'GitHub',
        url: 'https://github.com/ArvindPadala',
        icon: '↗',
    },
    {
        name: 'LinkedIn',
        url: 'https://www.linkedin.com/in/arvindcharypadala/',
        icon: '↗',
    },
    {
        name: 'Medium',
        url: 'https://medium.com/@padalaarvindchary1',
        icon: '↗',
    },
] as const;
